import {CONSTANTS} from "../common/constants";
import {formatCurrency, formatDate} from "../common/Utils";
import {Chip} from "@mui/material";
import Icon from "@mui/material/Icon";
import React from "react";

export default function DisplayPerk({perk}) {

  const frequencyRestriction = (perk) => {
    if (!perk?.frequencyRestricted) {
      return '';
    }

    for (let k in CONSTANTS.PERK_FREQUENCY_TYPES) {
      if (CONSTANTS.PERK_FREQUENCY_TYPES[k].id === perk.frequencyRestrictedType) {
        return ' ('  + perk.frequencyRestriction + ' per ' +  CONSTANTS.PERK_FREQUENCY_TYPES[k].name + ')';
      }
    }

    return '';

  }
  return (
    <>
      <b>Name:</b> {perk.name}
      <br/>
      <p>
        <small>
          <b>Type:</b> {perk?.perkType?.name}<br/>
          {perk?.perkType?.id === CONSTANTS.PERK_TYPE.PRODUCT && <>
            <b>Item:</b> {perk.inventory?.name}
          </>}
          {perk?.perkType?.id === CONSTANTS.PERK_TYPE.DISCOUNT && <>
            <b>Discount:</b> {perk.discountPercentage}%
          </>}
          {perk?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT && <>
            <b>Credit:</b> {formatCurrency(perk.storeCreditValue)}
          </>}<br/>
          <b>Recurrence:</b> {perk?.recurrenceType?.name}
          {perk?.timeRestricted && <><br/>
            <b>Expires:</b> {formatDate(perk?.expirationDate)}
          </>}
          <br/>
          <b>Unlimited:</b> {perk?.unlimitedUsage ? 'Yes' : 'No'}
        </small>
      </p>

      {perk.createDate && <Chip className={'m-chip'}
                                color="secondary"
                                variant="outlined"
                                label={'Created on: ' + (formatDate(perk.createDate))}/>}

      {perk?.unlimitedUsage && <Chip className={'mb-2'}
                                     color="secondary"
                                     icon={<Icon>loop</Icon>}
                                     variant="outlined"
                                     label={' Unlimited' + frequencyRestriction(perk) }/>}
    </>
  )
}
